import React from 'react';
import { Label } from "reactstrap";

// eslint-disable-next-line react/prop-types
const renderField = ({ input, label, errorLabel, placeholder, type, meta: { touched, error, warning } }) => (
  <>
    <Label className="label-taxi">{label}</Label>
    <div>
      <input {...input} placeholder={placeholder} type={type} className="form-control"/>
      {touched && ((error && <span className="error">{`${errorLabel ? errorLabel:label} ${error}`}</span>) || (warning && <span>{warning}</span>))}
    </div>
  </>
)

export default renderField;